<template>
  <aside class="zlc-sidebar">
    <div class="zlc-brand" @click="goHome">
      <div class="zlc-brand-image"><img :src="brandLogo" alt="智联车途" /></div>
      <div class="zlc-brand-copy"><strong>智联车途</strong><small>安全生产管理平台</small></div>
    </div>
    <div class="zlc-company" :title="baseInfo.shop_name || '当前单位'">
      <div class="zlc-company-avatar"><i class="el-icon-office-building"></i></div>
      <div class="zlc-company-info"><span class="zlc-company-label">当前管理单位</span><strong>{{ baseInfo.shop_name || '单位管理端' }}</strong></div>
      <i class="el-icon-check zlc-company-check"></i>
    </div>
    <div class="zlc-menu-heading">业务工作台</div>
    <div class="zlc-nav-scroll">
      <div class="zlc-nav-home" :class="{'is-active': $route.path === '/home' || $route.path === '/'}" @click="goHome">
        <i class="el-icon-data-board"></i><span>工作台</span>
      </div>
      <template v-for="(item, index) in navList">
        <div class="zlc-nav-group" :key="item.access_id || ('group-'+index)">
          <div class="zlc-nav-parent" :class="{'is-open': expanded === index, 'is-active': activeGroup === index}" @click="toggleGroup(item, index)">
            <i :class="groupIcon(item, index)"></i><span class="zlc-nav-parent-label">{{ displayName(item.name) }}</span>
            <i v-if="visibleChildren(item).length" class="el-icon-arrow-down zlc-nav-arrow" :class="{'is-rotate': expanded === index}"></i>
          </div>
          <div v-if="expanded === index && visibleChildren(item).length" class="zlc-nav-children">
            <div v-for="(child, ci) in visibleChildren(item)" :key="child.access_id || ci" class="zlc-nav-link" :class="{'is-active': matches(child)}" @click="goNode(child)">
              <span class="zlc-nav-dot"></span><span>{{ displayName(child.name) }}</span>
            </div>
          </div>
        </div>
      </template>
      <div v-if="!navList.length" class="zlc-nav-empty">暂无已授权业务模块，请联系管理员分配权限</div>
    </div>
    <div class="zlc-sidebar-foot"><i class="el-icon-lock"></i> 企业数据 · 权限隔离<br/><small>智联车途 · 安全生产管理</small></div>
  </aside>
</template>
<script>
import bus from '@/utils/eventBus.js';
import {getSessionStorage} from '@/utils/base';
import brandLogo from '@/assets/logo_zlc.png';
export default {
  inject: ['baseInfo'],
  data(){ return {brandLogo, menuList: [], expanded: -1, activeGroup: -1}; },
  computed:{
    navList(){
      return (this.menuList || []).filter(item => item && Number(item.is_menu) === 1 && !this.isHome(item));
    }
  },
  created(){
    this.updateMenu();
    bus.$on('headLoad', this.handleLoad);
  },
  beforeDestroy(){bus.$off('headLoad', this.handleLoad);},
  watch:{'$route.path':function(){this.selectMenu();}},
  methods:{
    handleLoad(){ this.updateMenu(); },
    updateMenu(){
      const role = getSessionStorage('rolelist');
      this.menuList = Array.isArray(role) ? role : [];
      this.$nextTick(this.selectMenu);
    },
    isHome(node){return /^(\/|\/home|home|概况|首页|工作台)$/i.test(String(node.path || node.name || ''));},
    displayName(name){
      if (/插件|应用中心|营销应用|营销插件/.test(name || '')) return '安全生产业务';
      if (/商城|商家中心|店铺/.test(name || '')) return '企业管理';
      return name || '业务管理';
    },
    groupIcon(node, i){
      const s = (node.name || '') + ' ' + (node.path || '');
      if (/权限|角色|管理员|系统/.test(s)) return 'el-icon-setting';
      if (/培训|课件|学习|考试/.test(s)) return 'el-icon-reading';
      if (/车辆|运输/.test(s)) return 'el-icon-truck';
      if (/企业|组织|人员/.test(s)) return 'el-icon-office-building';
      if (/安全|风险|隐患|应急/.test(s)) return 'el-icon-warning-outline';
      return i % 2 ? 'el-icon-folder-opened' : 'el-icon-menu';
    },
    visibleChildren(node){return (node.children || []).filter(child => child && Number(child.is_menu) === 1);},
    nodePath(node){
      if (this.visibleChildren(node).length) return this.nodePath(this.visibleChildren(node)[0]);
      return node.path || node.redirect_name || '';
    },
    matches(node){
      const p = String(this.$route.path || '').toLowerCase();
      const path = String(node.path || '').toLowerCase();
      const redirect = String(node.redirect_name || '').toLowerCase();
      return p === path || (!!redirect && p === redirect) || (path && p.indexOf(path + '/') === 0);
    },
    selectMenu(){
      const index = this.navList.findIndex(item => this.matches(item) || this.visibleChildren(item).some(child => this.matches(child)));
      this.activeGroup = index;
      if(index >= 0) this.expanded = index;
      const current = index >= 0 ? this.navList[index] : null;
      const selected = current && this.visibleChildren(current).find(n => this.matches(n));
      bus.$emit('menuName', selected ? this.displayName(selected.name) : current ? this.displayName(current.name) : '工作台');
      this.$emit('selectMenu', index >= 0 ? index : null);
    },
    toggleGroup(item,index){
      if(!this.visibleChildren(item).length){this.goNode(item);return;}
      this.expanded = this.expanded === index ? -1 : index;
    },
    goNode(node){
      const path = this.nodePath(node);
      if(path && path !== this.$route.path) this.$router.push(path);
      else if(!path) this.$message.warning('此菜单暂未配置路由');
    },
    goHome(){this.$router.push('/home');}
  }
};
</script>
<style scoped>
.zlc-sidebar{flex:0 0 252px;width:252px;height:100vh;display:flex;flex-direction:column;background:#10294e;color:#dce9fc;overflow:hidden;box-shadow:6px 0 32px rgba(17,49,95,.09);z-index:12}
.zlc-brand{height:94px;flex-shrink:0;display:flex;align-items:center;padding:17px 17px;gap:11px;background:#0c2445;cursor:pointer}
.zlc-brand-image{width:53px;height:53px;border-radius:14px;background:#fff;display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0;padding:2px}.zlc-brand-image img{max-width:100%;max-height:100%;object-fit:contain}
.zlc-brand-copy strong{display:block;font-size:20px;letter-spacing:2px;color:#fff;line-height:26px}.zlc-brand-copy small{display:block;margin-top:3px;font-size:11px;color:#9fb8da;letter-spacing:1px}
.zlc-company{margin:19px 13px 13px;background:#1c3a62;border:1px solid #305073;border-radius:13px;display:flex;gap:10px;align-items:center;padding:12px 10px;min-width:0}
.zlc-company-avatar{width:33px;height:33px;border-radius:9px;background:#2e5792;color:#bbd7ff;display:flex;align-items:center;justify-content:center;font-size:17px;flex-shrink:0}.zlc-company-info{flex:1;min-width:0}.zlc-company-info strong{display:block;font-size:13px;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.zlc-company-label{display:block;font-size:11px;color:#abc4e4;margin-bottom:3px}.zlc-company-check{color:#65c3fa;font-size:12px}
.zlc-menu-heading{padding:19px 22px 10px;letter-spacing:2px;color:#7796be;font-size:11px}.zlc-nav-scroll{flex:1;overflow-y:auto;padding:0 11px 24px}.zlc-nav-scroll::-webkit-scrollbar{width:4px}.zlc-nav-scroll::-webkit-scrollbar-thumb{background:#345675;border-radius:4px}
.zlc-nav-home,.zlc-nav-parent{min-height:44px;display:flex;align-items:center;gap:12px;padding:0 13px;font-size:13px;color:#cbdbf0;border-radius:10px;cursor:pointer;transition:.2s ease;margin:3px 0}.zlc-nav-home i,.zlc-nav-parent>i:first-child{font-size:18px;width:20px;text-align:center}.zlc-nav-home:hover,.zlc-nav-parent:hover,.zlc-nav-parent.is-active{background:#1f406b;color:#fff}.zlc-nav-home.is-active{background:#2e69d3;color:#fff;font-weight:600}.zlc-nav-parent-label{flex:1}.zlc-nav-arrow{margin-left:auto;font-size:11px;transition:transform .2s}.zlc-nav-arrow.is-rotate{transform:rotate(180deg)}
.zlc-nav-children{margin:2px 0 8px 30px;padding:3px 0 3px 11px;border-left:1px solid #365377}.zlc-nav-link{cursor:pointer;min-height:37px;padding:9px 10px;display:flex;gap:9px;align-items:center;color:#b7cce9;font-size:12px;border-radius:8px;transition:.15s}.zlc-nav-link:hover{background:#1d406d;color:#fff}.zlc-nav-link.is-active{color:#fff;background:#2454a4}.zlc-nav-dot{width:5px;height:5px;background:#6c93c2;border-radius:50%;flex-shrink:0}.zlc-nav-link.is-active .zlc-nav-dot{background:#68d9ea}.zlc-nav-empty{padding:16px;font-size:12px;line-height:1.9;color:#9bb5d5}.zlc-sidebar-foot{border-top:1px solid #27466a;padding:16px 21px 19px;font-size:12px;line-height:22px;color:#9fbcdf}.zlc-sidebar-foot small{font-size:11px;color:#7896bc}
</style>



// WEBPACK FOOTER //
// src/views/layout/LeftMenu.vue